import { ContractTemplateDTO } from '@/core/collections/contracts-api/customers/contract-templates/contract-template.interface';
import { inject, Ref, ref } from 'vue';

export function useContractTemplate() {
   const contractTemplate = inject('contractTemplate', ref({})) as Ref<ContractTemplateDTO>;

   return contractTemplate;
}
